import { useNavigate } from 'react-router-dom';
import Title from '../components/shared/Title';
import WordCloud from '../components/team/WordCloud';
import BgTalkUs from '../assets/imgs/bg-talk-us.webp';
import AdvisoryContainer from '../components/team/AdvisoryContainer';
import SherpasContainer from '../components/team/SherpasContainer';
import ManagementContainer from '../components/team/ManagementContainer';
import MeetTeamContainer from '../components/team/MeetTeamContainer';
import Button from '../components/shared/Button';

const Team = () => {
  const navigate = useNavigate();
  const handleContactClick = () => {
    navigate('/', { state: { scrollToContact: true } });
  };
  return (
    <>
      <div className="bg-custom md:px-52 py-20 px-10">
        <div className="3xl:max-w-[1500px] 3xl:inline-block">
          <MeetTeamContainer />
        </div>
      </div>
      <div className="py-14 xl:px-52 md:px-20 px-10">
        <div className="3xl:max-w-[1500px] 3xl:inline-block mb-16">
          <ManagementContainer />
          <div className="text-center mt-5">
            <Button
              className="border border-blue-900 bg-blue-900 text-white-50 hover:text-blue-800 hover:bg-white-100 focus:bg-white-100 active:bg-white-200"
              onClick={() => handleContactClick()}
            >
              Let's talk!
            </Button>
          </div>
        </div>
        <div className="3xl:max-w-[1500px] 3xl:inline-block">
          <SherpasContainer />
        </div>
      </div>
      <div className="my-20">
        <Title text1="Why be" text2="a Sherpa?" colorForText={2} />
        <WordCloud />
      </div>
      <div className="bg-white-100 py-14 bg-center bg-cover bg-no-repeat xl:px-52 md:px-20 px-10" style={{ backgroundImage: `url(${BgTalkUs})` }}>
        <div className="3xl:max-w-[1500px] 3xl:inline-block">
          <AdvisoryContainer />
        </div>
      </div>
    </>
  );
};

export default Team;